import { render, staticRenderFns } from "./ChargingPointDetailMessages.vue?vue&type=template&id=98477aae"
import script from "./ChargingPointDetailMessages.vue?vue&type=script&lang=js"
export * from "./ChargingPointDetailMessages.vue?vue&type=script&lang=js"
import style0 from "./ChargingPointDetailMessages.vue?vue&type=style&index=0&id=98477aae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports